<template lang="pug">
	table.table.table-striped.m-0
		thead
			tr
				th Contenidos
		tbody
			tr(v-for="contenido in listadoContenidos", @click="seleccionaPrograma(contenido)", :class="colocacion.ContenidoID === contenido.ContenidoID ? 'bg-danger text-white' : ''", style="cursor:pointer;")
				td ({{contenido.HoraInicio}} - {{contenido.HoraFin}}) {{contenido.Nombre}}
</template>

<script>
export default {
	props: ['EmisoraID', 'colocacion'],
	data () {
		return {
			listadoContenidos: []
	   }
	},
	created () {
		// Obtenemos los programas de esa emisora
		this.$http.post('gestion-emisoras/php/api/contenidos/buscar-contenidos.php', {EmisoraID: this.EmisoraID})
			.then(res => {
				this.listadoContenidos = res.data.listado
			})
			.catch(this.$responseError)
	},
	methods: {
		seleccionaPrograma (contenido) {
			this.colocacion.ContenidoID = contenido.ContenidoID
			this.colocacion.ContenidoNombre = contenido.Nombre
			this.colocacion.HoraInicio = contenido.HoraInicio
			this.colocacion.HoraFin = contenido.HoraFin
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/colocacion/contenido.vue